import React, { createContext, useReducer } from "react"

import { useApi } from "../api/useApi"
import { createActions } from "./actions/actions"

import { reducer, initialState, AppState, Actions } from "./store"

type AppProviderProps = {
  children: React.ReactNode
}

export type AppContextInterface = {
  actions: Actions
  state: AppState
  api: any
}

export const AppContext = createContext<AppContextInterface | null>(null)
const { Provider } = AppContext

export const AppProvider = (props: AppProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const actions = createActions(dispatch)
  const api = useApi(state, actions)
  return <Provider value={{ state, actions, api }}>{props.children}</Provider>
}
